import React, { Component, Fragment } from 'react'
import config from '../../../config'
import { Container, Row, Card, Jumbotron, Col, Form, Button } from 'react-bootstrap'
import SearchItem from '../../subcomponent/searchItem'
import Mensajes from '../../subcomponent/mensajes'

import errores from '../../../middleware/errordb'
import { IoIosRemoveCircle } from "react-icons/io";
import { IconContext } from "react-icons";
import { Table } from 'react-bootstrap'

export class ingresoInventario extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            empresa: currentCompany,
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: "",
            data_items: [],
            lista_bodegas: [],
            consecutivos: [],
            list_items: [],
            bodega: "",
            numero: 0,
            proveedor: 1,
            tipoMov: "",
            observacion: "",
            fecha: "",
            items_barcode: []
        }
    }

    componentDidMount() {
        this.initInventario();
    }

    initInventario = () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;

        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/inventary', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    //console.log(datos[4])
                    this.setState({
                        data_items: datos[0],
                        lista_bodegas: datos[1],
                        consecutivos: datos[3],
                        items_barcode: datos[4],
                        fecha: todayFormat
                    });
                } else {
                    //console.log(data);
                    this.setState({ mostrarMensaje: true, mensaje: data.message })
                }
            });
    }

    addItem = (itemSelect) => {
        let new_list_items = this.state.list_items
        let control = 0;

        const LISTA_UNI = (itemSelect.LISTA_UNIDADES || [])
        let UNIDAD_MEDIDA = "";
        LISTA_UNI.forEach(element => {
            if (element.FACTOR === 1) {
                UNIDAD_MEDIDA = element.ID_UNIDAD + ";;" + element.DESCRIPCION_FACTOR + ";;" + element.PRECIO + ";;" + element.FACTOR;
            }
        });

        new_list_items.forEach(element => {
            if (element.ID_ITEMS.toString() === itemSelect.ID_ITEMS.toString()) {
                control++;
            }
        });

        const dataUni = UNIDAD_MEDIDA.split(";;");

        if (control === 0) {
            itemSelect.motivo = "E";
            itemSelect.cantidad = 0;
            itemSelect.cantidad2 = 0;
            itemSelect.costo = 1;
            itemSelect.tipo = "-";
            itemSelect.observacion = "";
            itemSelect.UNIDAD_MEDIDA = UNIDAD_MEDIDA;
            itemSelect.FACTOR = dataUni[3];
            itemSelect.ID_UNIDAD = dataUni[0];


            new_list_items.unshift(itemSelect);
            this.setState({
                list_items: new_list_items
            });
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const { empresa } = this.state;
        const { bodega } = this.state;
        const { proveedor } = this.state;
        const { tipoMov } = this.state;
        const { observacion } = this.state;
        const { numero } = this.state;
        const { list_items } = this.state;

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa,
                bodega,
                proveedor,
                tipoMov,
                observacion,
                numeroDoc: numero,
                items: list_items
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/inventary/create', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    this.initInventario();
                    this.setState({
                        mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente",
                        bodega: "",
                        descripcion: "",
                        cantidad: 1,
                        proveedor: 1,
                        costo: 0,
                        numero: 0,
                        tipoMov: "",
                        observacion: "",
                        list_items: []
                    })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Ingreso con errores:" + errores[data.code] + " " + data.message })
                }
            });
    }

    changeTipo = ({ target }) => {
        let numero = 1;
        const { consecutivos } = this.state;

        if (target.value === "") numero = 0;
        consecutivos.forEach(element => {
            if (element.TIPO_MOVIMIENTO === target.value) numero = element.NUM;
        });

        this.setState({
            tipoMov: target.value,
            numero
        })
    }

    modifyInput = (i, { target }) => {
        let new_list_items = this.state.list_items

        new_list_items.forEach((element, index) => {
            if (index === i) {
                element[target.id] = target.value;
            }
        });

        this.setState({
            list_items: new_list_items
        });
    }

    removeitem = (index) => {
        let newData = this.state.list_items;
        newData.splice(index, 1);
        this.setState({ list_items: newData });
    }

    changeUnit = ({ target }, index) => {
        const newDetalle = this.state.list_items;
        newDetalle.forEach((element, i) => {
            if (index === i) {
                const datos = target.value.split(";;");
                element.UNIDAD_MEDIDA = target.value;
                element.FACTOR = datos[3];
                element.ID_UNIDAD = datos[0];
            }
        });
        this.setState({ list_items: newDetalle });
    }

    addItemBarCode = (itemSelect) => {
        let new_list_items = this.state.list_items
        let control = 0;

        const LISTA_UNI = (itemSelect.LISTA_UNIDADES || [])
        let UNIDAD_MEDIDA = "";
        LISTA_UNI.forEach(element => {
            if (element.FACTOR === 1) {
                UNIDAD_MEDIDA = element.ID_UNIDAD + ";;" + element.DESCRIPCION_FACTOR + ";;" + element.PRECIO + ";;" + element.FACTOR;
            }
        });

        new_list_items.forEach(element => {
            if (element.ID_ITEMS.toString() === itemSelect.ID_ITEMS.toString()) {
                control++;
            }
        });

        const dataUni = UNIDAD_MEDIDA.split(";;");

        if (control === 0) {
            itemSelect.motivo = "E";
            itemSelect.cantidad = itemSelect.CANTIDAD_BARCODE;
            itemSelect.cantidad2 = itemSelect.CANTIDAD_BARCODE;
            itemSelect.costo = 1;
            itemSelect.tipo = "-";
            itemSelect.observacion = "";
            itemSelect.UNIDAD_MEDIDA = UNIDAD_MEDIDA;
            itemSelect.FACTOR = dataUni[3];
            itemSelect.ID_UNIDAD = dataUni[0];


            new_list_items.unshift(itemSelect);
            this.setState({
                list_items: new_list_items
            });
        }
    }

    render() {
        const { lista_bodegas } = this.state;
        const { list_items } = this.state;
        const { items_barcode } = this.state;
        const modifyInput = this.modifyInput;
        const removeitem = this.removeitem;
        const changeUnit = this.changeUnit;
        return (
            <Fragment>

                <Jumbotron className="Jumbotron">
                    <h2>Ingreso de Inventario</h2>
                </Jumbotron>
                <Container>
                    <Card className="card">
                        <Card.Body>
                            <Form className="form" onSubmit={this.handleSubmit}>
                                <Row>
                                    <Col sm={3}>
                                        <SearchItem data={this.state.data_items} event={this.addItem} data_barcode={items_barcode} event_barcode={this.addItemBarCode}></SearchItem>
                                    </Col>
                                    <Col sm={9}>
                                        <Form.Control type="hidden" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled />
                                        <Form.Row>
                                            <Form.Group as={Col} controlId="">
                                                <Form.Label>Tipo de ingreso</Form.Label>
                                                <Form.Control as="select" onChange={this.changeTipo} value={this.state.tipoMov} required >
                                                    <option value="">Seleccione</option>
                                                    <option value="SI">Inventario Inicial</option>
                                                    <option value="DE">Devolucion</option>
                                                    <option value="EI">Entrada Inventario</option>
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="">
                                                <Form.Label>Numero</Form.Label>
                                                <Form.Control type="text" value={this.state.tipoMov + '-' + this.state.numero} required readOnly />
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="">
                                                <Form.Label>Fecha</Form.Label>
                                                <Form.Control type="text" value={this.state.fecha} required readOnly />
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="">
                                                <Form.Label>Bodega</Form.Label>
                                                <Form.Control as="select" onChange={e => this.setState({ bodega: e.target.value })} value={this.state.bodega} required >
                                                    <option value="">Seleccione</option>
                                                    {
                                                        lista_bodegas.map((bodega, i) => {
                                                            return (<option key={'b' + i} value={bodega.ID_BODEGAS}>{bodega.DESCRIPCION_BODEGA}</option>)
                                                        })
                                                    }
                                                </Form.Control>
                                            </Form.Group>
                                        </Form.Row>
                                        <Form.Row>
                                            <Form.Group as={Col} controlId="">
                                                <Form.Control placeholder="Observacion" min="1" type="text" onChange={(e) => this.setState({ observacion: e.target.value })} value={this.state.observacion} />
                                            </Form.Group>
                                        </Form.Row>
                                        <div className="tableFixHead">
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Ref.</th>
                                                        <th>Descripcion</th>
                                                        <th>U.M.</th>
                                                        <th>Cantidad</th>
                                                        <th>Costo</th>
                                                        <th>Costo Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        list_items.map((element, i) => {
                                                            return (
                                                                <tr key={'r' + i}>
                                                                    <td>
                                                                        <IconContext.Provider value={{ size: "2em" }}>
                                                                            <IoIosRemoveCircle onClick={() => removeitem(i)} />
                                                                        </IconContext.Provider>
                                                                    </td>
                                                                    <td>{element.REFERENCIA_ITEM}</td>
                                                                    <td>
                                                                        {element.DESCRIPCION_ITEM}
                                                                    </td>
                                                                    {<td>
                                                                        <Form.Control as="select" onChange={(e => changeUnit(e, i))} value={element.UNIDAD_MEDIDA} required>
                                                                            {element.LISTA_UNIDADES.map(function (currentUnit, j) {
                                                                                return <option key={'un' + j} value={currentUnit.ID_UNIDAD + ";;" + currentUnit.DESCRIPCION_FACTOR + ";;" + currentUnit.PRECIO + ";;" + currentUnit.FACTOR} >{currentUnit.DESCRIPCION_FACTOR}</option>;
                                                                            })}
                                                                        </Form.Control>
                                                                    </td>}
                                                                    <td>
                                                                        <Form.Control min="1" id="cantidad" className="shortinput" type="number" onChange={(e) => modifyInput(i, e)} value={element.cantidad} required />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control min="0" id="costo" className="mediuminput" type="number" onChange={(e) => modifyInput(i, e)} value={element.costo} required />
                                                                    </td>
                                                                    <td className="currSign"> {Intl.NumberFormat('es-MX').format(element.cantidad * element.costo)}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                        <Button className="m-3" variant="primary" type="submit" disabled={!(this.state.list_items.length > 0)} >Finalizar Documento</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Container>
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </Fragment>
        )
    }
}

export default ingresoInventario



// WEBPACK FOOTER //
// ./src/components/bussines/inventarios/ingresoInventario.jsx